<template>
    <div class="content-layout">
        <el-container>
          <el-header class="main-heard" >
           <el-row>
            <el-col :span="8">
                <el-menu
                    :default-active="activeIndexMenu"
                    mode="horizontal"
                    @select="selectMenu"
                >
                    <el-menu-item index="00" >
                        <ab-svg name="home"></ab-svg>
                        <template #title>首页</template>
                    </el-menu-item>
                    <el-menu-item index="01" v-if="bizType.clientImportRole">
                        <ab-svg name="jinkou"></ab-svg>
                        <template #title>进口</template>
                    </el-menu-item>
                    <el-menu-item index="02" v-if="bizType.clientExportRole">
                        <ab-svg name="chukou"></ab-svg>
                        <template #title>出口</template>
                    </el-menu-item>
                    <!-- <el-menu-item index="05" v-if="bizType.clientWmsRole">
                        <ab-svg name="cangchu"></ab-svg>
                        <template #title>仓储</template>
                    </el-menu-item> -->
                    <el-menu-item index="07" v-if="bizType.clientSalesRole">
                        <ab-svg name="xiaoshou"></ab-svg>
                        <template #title>生意宝</template>
                    </el-menu-item>
                    <el-menu-item index="06" v-if="this.dataForm.step && this.dataForm.step == '99'">
                        <ab-svg name="wode"></ab-svg>
                        <template #title>我的</template>
                    </el-menu-item>
                </el-menu>
            </el-col>
             <el-col :span="8" class="nav-conter">
                <img src="@/assets/img/logo.png" />
                <div class="ab-select" @click="getOrginzer" v-if="this.dataForm.step && this.dataForm.step == '99'">{{userInfo.companyName}}<ab-svg name="zhuti"></ab-svg></div>
             </el-col>
             <el-col :span="8" class="nav-right">
                <div class="system-change" @click="sysChange" v-if="this.dataForm.step == '99'">
                    <img src="@/assets/img/syschange.png" />
                </div>
                <ul>
                    <li @click="$refs.feedback.init()"><el-badge :value="unReadCount" :hidden="!unReadCount"><ab-svg name="fankui"></ab-svg>反馈</el-badge></li>
                    <li @click="$refs.notice.init()"><ab-svg name="gonggao"></ab-svg>公告</li>
                    <li @click="getService"><ab-svg name="kefu"></ab-svg>客服</li>
                    <el-badge :value="messageTotal" class="item" :hidden="messageTotal == 0">
                        <li @click="msgDrawer.show = true"><ab-svg name="xiaoxi"></ab-svg>消息</li>
                    </el-badge>
                    <li>
                        <div class="user-info">
                            <el-dropdown @command="handleUserCommand" placement="bottom-end" trigger="click">
                                <span class="el-dropdown-link">
                                    <div class="user-name">
                                        <img :src="attachUrl ? attachUrl : require('../../assets/img/user-1.png')" />
                                    </div>
                                </span>
                                <template #dropdown>
                                    <el-dropdown-menu>
                                        <el-dropdown-item command="1">
                                            <i style="line-height: 12px;"><ab-svg name="user" style="width: 14px; height: 14px;"></ab-svg></i>
                                            个人中心
                                        </el-dropdown-item>
                                        <el-dropdown-item command="2">
                                            <i style="line-height: 12px;"><ab-svg name="switchButton" style="width: 14px; height: 14px"></ab-svg></i>
                                            退出登陆
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </template>
                            </el-dropdown>
                        </div>
                    </li>
                </ul>
                
             </el-col>
           </el-row>
           <div class="yixiu-logo" v-if="isHelp">
                <img src="@/assets/img/yixiu-gb.png" class="logo-1" />
                <span class="tex" @click="helpMesg">Hi~我是一咻哥，有问题请点我！</span>
                <img class="logo-2" src="@/assets/img/yixiu-gb2.png"/>
           </div>
          </el-header>
          <el-container  class="content">
            <el-aside :class="{'main-left': true, 'isHidden': sidebarFold}">
                <mainMenu ref="menu"></mainMenu>
            </el-aside>
            <el-main class="main-content">
                <el-tabs type="card" v-model="mainTabsActiveName" class="nav-tab actived-manue" @tab-click="handleClick">
                    <el-tab-pane :label="item.name" :name="item.index" v-for="(item, idx) in mainTabs" :key="idx" >
                        <template #label>
                            {{item.name}}
                            <span v-if="item.name != '首页'" @click="handlerRemove(item.index)">
                                <ab-svg name="tab-close"></ab-svg>
                            </span>
                        </template>
                    </el-tab-pane>
                </el-tabs>
                <div class="tankage" :style="{'height': (documentClientHeight - 151) + 'px'}">
                    <div class="tankage-main">
                        <router-view v-slot="{ Component }" @childClick="clickGetMenus">
                            <keep-alive :include="keepAliveView">
                                <component ref="keepView" :is="Component" :class="{'ab-content-details': $route.meta.keepAlive}" :key="$route.index" />
                            </keep-alive>
                        </router-view>
                    </div>
                </div>
            </el-main>
            
          </el-container>
          <el-footer>
                <div class="footer">
                    <img src="@/assets/img/footer.png"/>
                    <span class="file">一咻通关-自助通关平台开创者</span>
                </div>
            </el-footer>
        </el-container>
        <div class="sidebarfold" v-if="isfold" @click="handlerFold">
            <ab-svg name="zhedie"></ab-svg>
        </div>
    
        
        <ab-coupon :couponDialog="couponDialog" @closeDialog="closeDialog">
        </ab-coupon>
        <el-dialog
          class="willExpireDialog"
          title="温馨提示"
          :v-model="willExpireDialogVisible"
          width="20%"
          top="20%"
        >
          <span style="font-size: 16px"
            >您有{{willExpireList ? willExpireList.length : 0
            }}张合计金额{{ couponTotal }}元的优惠券即将到期，请记得使用哦!</span
          >
          <template #footer class="dialog-footer">
            <el-button type="primary" @click="dialogData.show = true"
              >查看优惠券</el-button
            >
          </template>
        </el-dialog>
        <el-dialog
            v-model="organizerDialog.show"
            title="切换主体"
            class="organizer-dialog"
            append-to-body
            width="512px"
            :before-close="organizerClose"
        >
            <div>
                <div class="org-item" @click="checkedOrganizer(idx)" :class="{'isActived': organizerDialog.idx == ownOrgIds[idx]}" v-for="(obj, idx) in ownOrgArry" :key="idx">
                    <div class="org-tel" @click="checkIsTaxes">
                        <el-icon><ArrowDownBold /></el-icon>
                    </div>
                    <div class="org-name">{{obj}}</div>
                </div>
            </div>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="organizerClose">取消</el-button>
                    <el-button type="primary" @click="checkedOwrg">
                    确定
                    </el-button>
                </span>
            </template>
        </el-dialog>
        <feedback ref="feedback" @feedCallbank="getCustomerFeedbackList"></feedback>
        <message :drawer="msgDrawer" @mesList="mesList"></message>
        <notice ref="notice"></notice>
        <el-drawer
            v-model="service.show"
            title="咨询客服"
           
            custom-class="service-dialog"
            :before-close="serviceClose"
            modal-class="customer"
        >
            <div class="customerService" v-if="this.dataForm.step && this.dataForm.step == '99'">
                <div class="img">
                    <img src="@/assets/img/service.png" alt="">
                </div>
                <div class="name">{{customerInfo.name}}</div>
                <div class="info">
                    <div class="phone">
                        <ab-svg name="phone"></ab-svg>
                        {{customerInfo.mobile}}
                    </div>
                    <div class="email">
                        <ab-svg name="email"></ab-svg>
                        {{customerInfo.email}}
                    </div>
                </div>
                <div class="address">
                    <ab-svg name="address"></ab-svg>
                    <div>{{customerInfo.address}}</div>
                    
                </div>
            </div>
            <img src="@/assets/img/wxs-qc.jpg" v-else/>
        </el-drawer>
       
    
        <!-- 常见问题 -->
        <ab-issue ref="issue" :ishelp="isHelp"></ab-issue>
    </div>
    </template>
    
    <script>
    import mainMenu from './main-menu.vue'
    // import ws from "../../utils/ws";
    import { h } from 'vue'
    import feedback from './feedback.vue'
    import message from './message.vue'
    import notice from './notice.vue'
    import vueCookie from 'vue-cookies'
    export default {
        components: {
            mainMenu,
            feedback,
            message,
            notice
        },
        data () {
            return {
                willExpireDialogVisible: false,
                couponDialog: {
                    show: false,
                    couponList: []
                },
                disCouDialog: false, // 折扣券弹框
                config: {
                    disabled: ["google", "facebook", "twitter", "tencent"],
                    url: this.shareLink,
                    image: "",
                    wechatQrcodeTitle: "微信扫一扫：分享", // 微信二维码提示文字
                    wechatQrcodeHelper:
                    "<p>微信里点“发现”，扫一下</p><p>二维码便可将本文分享至朋友圈。</p>"
                },
                noticeList: {},
                value: '',
                routeQuery: {},
                bizType: {
                    clientImportRole: false,
                    clientExportRole: false,
                    clientWmsRole: false,
                    clientSalesRole: false,
                    activeIndex: this.activeIndexMenu
                },
                ownOrgArry: [],
                ownOrgIds: [],
                mainOrgId: '',
                isReload: true,
                userInfo: {},
                activeName:'first',//消息
                drawer:false,//消息抽屉
                drawer2:false,//公告抽屉
                innerDrawer:false,
                organizerDialog: {
                    show: false,
                    idx: ''
                },
                service: {
                    show: false
                },
                msgDrawer: {
                    show: false
                },
                dataForm: {},
                attachUrl: '',
                companyData: {},
                //消息数量
                messageTotal: '',
                isHelp: true,
                //签约后客服信息
                customerInfo: {},
                webSock: null,
                lockReconnect: false, //防止重复
                timer: null,
                unReadCount: 0
            }
        },
        computed: {
            activeIndexMenu: {
                get() {
                    return (
                        this.$store.state.activeIndexMenu 
                    )
                } ,
                set(val) {
                    this.$store.commit("activeIndex", val)
                }
            },
            shareLink: {
            get() {
                return (
                this.$store.state.shareLink ||
                window.localStorage.getItem("shareLink")
                )
            },
            set(val) {
                this.$store.commit("updaetShareLink", val)
            }
            },
            nowMoney: {
                get() {
                    return this.$store.state.nowMoney
                },
                set(val) {
                    this.$store.commit("updaetNowMoney", val)
                }
            },
            balanceIntegral: {
                get() {
                    return this.$store.state.balanceIntegral
                },
                set(val) {
                    this.$store.commit("updaetBalanceIntegral", val)
                }
            },
            coupon: {
                get() {
                    return this.$store.state.coupon
                },
                set(val) {
                    this.$store.commit("updaetCoupon", val)
                }
            },
            showCouponDia: {
                get() {
                    return this.$store.state.showCouponDia
                },
                set(val) {
                    this.$store.commit("updaetCouponDia", val)
                }
            },
            disCouList: {
                get() {
                    return this.$store.state.disCouList
                },
                set(val) {
                    this.$store.commit("updaetDisCouList", val)
                }
            },
            documentClientHeight: {
                get() {
                    return this.$store.state.documentClientHeight;
                },
                set(val) {
                    this.$store.commit('updateDocumentClientHeight', val);
                }
            },
            sidebarFold: {
                get () {
                    return this.$store.state.sidebarFold
                },
                set (val) {
                    this.$store.commit('updateSidebarFold', val)
                }
            },
            activeMenu: {
                get () {
                    return this.$store.state.activeMenu
                },
                set (val) {
                    this.$store.commit('updateActiveMenu', val)
                }
            },
            mainTabs: {
                get () { return this.$store.state.mainTabs },
                set (val) { this.$store.commit('updateMainTabs', val) }
            },
            mainTabsActiveName: {
                get () { return this.$store.state.mainTabsActiveName },
                set (val) { this.$store.commit('updateMainTabsActiveName', val) }
            },
            isfold () {
                if (this.sidebarFold && ['01','02','05'].includes(this.bizType.activeIndex) && !this.$route.meta.keepAlive && !['我的', '首页'].includes(this.$route.name)) {
                    return true
                } else {
                    return false
                }
            },
            keepAliveView: {
                get () { return this.$store.state.keepAliveView },
                set (val) { this.$store.commit('updateKeepAliveView', val) }
            },
            bizTypeNow: {
                get() {
                    return (
                        this.$store.state.bizTypeNow 
                    )
                } ,
                set(val) {
                    this.$store.commit("nowBizType", val)
                }
            },
        },
        created () {
            if (this.$route.path != '/') {
                let activeMenu = this.$route.path.replace('/', '')
                if (!this.keepAliveView.includes(activeMenu)) {
                    this.keepAliveView.push(activeMenu)
                }
            }
            let query = this.$route.query || {}
            this.routeQuery = Object.keys(query).length ? query : this.routeQuery
            if (this.routeQuery.isOuter) {
                this.sidebarFold = true
            } else {
                this.sidebarFold = false
            }
            let bizType = this.$utils.getSessionStorage('bizType') || {}
            this.bizType.activeIndex = bizType.activeIndex
            this.activeIndexMenu = bizType.activeIndex
            if (!this.activeIndexMenu) {
                if (this.$route.path == '/') {
                    this.activeIndexMenu = '00'
                } else if (this.$route.path == '/my-list') {
                    this.activeIndexMenu = '06'
                } else if(this.bizType.activeIndex == '07') {
                    this.activeIndexMenu = '07'
                } else {
                    this.activeIndexMenu = '01'
                }
            }
            this.getUserInfo()
            this.getAttachUrl()
            this.getMessageList()
            // ws.init()
            // ws.showNotice = this.showNotice
            // ws.closeNotice = this.closeNotice
            // ws.getMessageList = this.getMessageList
            this.initWebSocket()
            this.getCurClientRegisterStep()
            if (!this.showCouponDia) {
                this.getWillExpireSoonCoupon()
            }
            if (this.$route.meta && this.$route.meta.keepAlive) {
                this.isHelp = false
            }
            this.getCustomerFeedbackList()
        },
        mounted() {
            this.documentClientHeight = document.documentElement['clientHeight']
            window.onresize = () => {
                this.documentClientHeight = document.documentElement['clientHeight']
            }
            // 公告调用
            this.$refs.notice.initDetail()
            this.getDataList()
            this.getCustomer()
        },
        methods: {
            //首页切换我的待办、一咻待办时，调用菜单请求。切换不同菜单
            clickGetMenus(){
                this.$refs.menu.getMenus()
            },
            initWebSocket () {
                var userId = localStorage.getItem('userId')
                let baseUrl = process.env.VUE_APP_BASEURL
                let wsKey = process.env.VUE_APP_WSK
                let hostname = ''
                if (window.location.hostname == 'localhost') {
                    hostname = baseUrl.substring(7, baseUrl.length)
                } else {
                    hostname =  window.location.hostname + '/api'
                }
                let wsUrl = wsKey + hostname + "/websocket?userId=" + userId
                if (this.timer != null && this.timer != undefined) {
                    clearInterval(this.timer)
                }
                this.timer = null
                this.webSock = new WebSocket(wsUrl)
                this.webSock.onopen = this.webSocketOnOpen
                this.webSock.onerror = this.webSocketOnError
                this.webSock.onmessage = this.showNotice
                this.webSock.onclose = this.webSocketClose
            },
            webSocketOnOpen() {
                console.log('WebSocket连接成功')
                this.timer = setInterval(() => {
                    if (this.webSock != null && this.webSock != undefined) {
                        this.webSock.send('keepAlive')
                    }
                }, 5000)
                //this.webSocketSend(this.id)
            },
            webSocketOnError(e) {
                console.log('报错信息', e)
            },
            webSocketSend(Data) {
                //发送数据发送
                this.webSock.send(Data)
            },
            webSocketClose(e) {
                console.log('断开连接', e)
                this.lockReconnect = false
                this.reconnect()
            },
            reconnect() {
                if (this.lockReconnect) return
                    this.lockReconnect = true
                    let _this = this
                //没连接上会一直重连，设置延迟避免请求过多
                setTimeout(function () {
                    _this.initWebSocket()
                    _this.lockReconnect = false
                    // _this.isOne = 1;
                }, 2000)
            },
            showPosterDia() {
            this.$get("/crm/spreadChannel/getSpreadByClient").then(({ data }) => {
                if (data.code === "C0000") {
                if (data.result) {
                    this.config.url = this.shareLink
                    if (data.result.shareUrlParam) {
                    if (
                        this.$utils.getSessionStorage("userInfo") &&
                        !localStorage.getItem(
                        this.$utils.getSessionStorage("userInfo").id
                        )
                    ) {
                        //获取账户可用优惠券
                        this.getCoupons()
                        this.showCouponDia = true
                    } else {
                        this.getCoupons()
                    }
                    }
                }
                }
            });
            },
            //委托方对应客服信息
            getCustomer(){
                this.$get('/bas/servProtocol/getBusinessManInfo').then( ({ data }) => {
                    if (data && data.code == "C0000") {
                        this.customerInfo = data.result
                    }
                })
            },
            getCouponsAvailable() {
            this.$post("/oms/client/couponEntry/list", {
                pageSize: 999,
                pageNum: 1
            }).then(({ data }) => {
                if (data.code === "C0000") {
                this.couponDialog.couponList = []
                let flag = false
                if (data.result && data.result.list && data.result.list.length > 0) {
                    data.result.list.forEach(ele => {
                    if (ele.isReceived === 0) {
                        this.couponDialog.couponList.push(ele)
                    }
                    if (ele.isReceived === 0) {
                        flag = true
                    }
                    })
                }
                if (flag) {
                    this.couponDialog.show = true
                }
                this.showCouponDia = flag
                }
            })
            },
            closeDialog() {
            this.showCouponDia = false
            //关闭弹框后自动领取优惠券  并查出最新优惠券
            this.couponDialog.show = false
            let ids = []
            this.couponDialog.couponList.forEach(ele => {
                ids.push(ele.id)
            })
            this.$post("/oms/client/couponEntry/receiveCoupon", { ids }).then(
                ({ data }) => {
                if (data.code === "C0000") {
                    this.$message({
                        type: 'success',
                        message: "领取成功",
                        offset: 380,
                        grouping: true,
                    })
                }
                this.getWillExpireSoonCoupon()
                this.$post("/oms/client/couponEntry/listCount", {
                    data: { queryCouponCode: true }
                }).then(({ data }) => {
                    if (data.code === "C0000") {
                    if (data.result) {
                        this.coupon = data.result
                    }
                    }
                })
                }
            )
            },
            //获取即将过期的优惠券
            getWillExpireSoonCoupon() {
            this.$post("/oms/client/couponEntry/willExpireList").then(({ data }) => {
                if (data.code === "C0000") {
                if (data.result && data.result.list && data.result.length > 0) {
                    this.willExpireList = data.result.list
                    this.willExpireDialogVisible = true
                }
                }
            })
            },
            getCurClientRegisterStep() {
            this.$get("/crm/clientRegisterStep/getCurClientRegisterStep").then(
                ({ data }) => {
                if (data && data.code == "C0000") {
                    // console.log(data.result, '认证状态')
                    this.dataForm = data.result
                    if (!this.dataForm) {
                    this.dataForm = { step: "99" }
                    }
                    this.$store.commit("SET_STEP", this.dataForm.step);
                    switch (this.dataForm.step) {
                    case "00": //温馨提示
                        this.isShow = true
                        break
                    case "01": //选择业务
                        this.isShow = true
                        break
                    case "02": //完善信息
                        this.companyData.enterpriseName = this.dataForm.enterpriseName
                        this.companyData.enterpriseMail = this.dataForm.enterpriseMail
                        this.isShow = true
                        break
                    case "03": //确认报价
                        this.isShow = true
                        break
                    case "04": //企业认证
                        this.isShow = true
                        break
                    case "05": //签署协议
                        this.isShow = true
                        break
                    case "99": //操作完成
                        this.getSign()
                        this.showPosterDia()
                        let stepDone = this.$utils.getSessionStorage("stepDone")
                        if (stepDone) {
                        setTimeout(() => {
                            //this.certificateDialog.show = true
                            this.$utils.removeSessionStorage("stepDone")
                            this.$router.push({path: '/'})
                        }, 200)
                        }
                    default:
                        this.isShow = false
                        break
                    }
                }
                }
            )
            },
            getCoupons() {
            this.$get("/oms/principalIntegral/get").then(({ data }) => {
                if (data.result) {
                this.balanceIntegral = data.result.companyIntegral
                this.nowMoney = data.result.nowMoney
                }
            })
            this.$get("/oms/couponTemplate/auto/pull").then(({ data }) => {
                if (data.code === "C0000") {
                if (data.result) {
                }
                }
                this.getCouponsAvailable()
            })
            },
            removeTabHandle() {
            this.mainTabs = this.mainTabs.filter(item => item.index !== this.mainTabsActiveName)
            this.$router.push({ path: "/" })
            },
            // 显示消息框
            showNotice(e) {
                const data = JSON.parse(e.data)
                console.log(data, '------------------------------------webscoket消息------------------------------------');
            if (data && data.typeName === "EVENT") { 
                this.$initSessionStorageData.getUserInfo().then(() => {
                if (data.title == "个人认证") {
                    //this.$refs.certificate.getCurClientRegisterStep()
                    window.location.reload(true)
                } else if (data.title == "企业认证") {
                    window.location.reload(true)
                // this.$refs.certificate.getCurClientRegisterStep()
                } else if (data.title == "签约成功" || data.title == "客户协议签署") {
                    this.$utils.setSessionStorage('stepDone', true)
                    this.removeTabHandle();
                    this.$get("/oms/businessWorkbench/getUserInfo").then(({data}) => {
                        if (data && data.code == 'C0000') {
                            this.bizType.clientExportRole = data.result.clientExportRole
                            this.bizType.clientImportRole = data.result.clientImportRole
                            this.bizType.clientSalesRole = data.result.clientSalesRole
                            window.location.reload()
                            return
                            if (this.bizType.clientExportRole) {
                                this.goOldSystem() //协议包含出口自动切换到老系统
                            } else {
                                window.location.reload(true)
                            }
                        }
                    })
                }else if(data.title == '新签一家协议') {
                    this.$post('/p/user/modMainOrgId', {id: data.billId, remark: 'bySign'}).then(({data}) => {
                    if (data && data.code == 'C0000') {
                        // this.$message.success('操作成功！')
                        this.removeTabHandle();
                    }
                    }).then(() => {
                    this.$get("/oms/businessWorkbench/getUserInfo").then(({data}) => {
                        if (data && data.code == 'C0000') {
                            this.$utils.setSessionStorage('userInfo', data.result)
                            this.bizType.clientExportRole = data.result.clientExportRole
                            this.bizType.clientImportRole = data.result.clientImportRole
                            this.bizType.clientSalesRole = data.result.clientSalesRole
                            window.location.reload()
                            return
                            if (this.bizType.clientExportRole) {
                                this.goOldSystem() //协议包含出口自动切换到老系统
                            } else {
                                window.location.reload()
                            }
                        }
                    })
                    })
                }else if(data.title == "增加业务协议") {
                    this.$router.push(
                        {
                            path: '/signProtocol-list',
                            query: {
                                activeName: 'signed'
                            }
                        }
                    )
                }
                // this.closeSealDialog();
                // setTimeout(() => {
                //   this.getCurrentUserStatus(type);
                // }, 50);
                })
                return
            }
            this.getMessageList();
            this.noticeList[data.id] = this.$notify({
                dangerouslyUseHTMLString: true,
                iconClass: "m-icon",
                customClass: "custom-message",
                duration: 10000,
                position: "bottom-right",
                title: data.title,
                message: h("div", null, [
                h(
                    "div",
                    { class: "notify-text", style: "word-break: break-all;"},
                    data.content
                ),
                h("div", { class: "notify-button" }, [
                    h(
                    "button",
                    {
                        onClick:  (e) => {
                            this.noticeReaded(e)
                        },
                        class: "el-button el-button--default el-button--small",
                        id: data.id
                      },
                    "忽略"
                    ),
                    h(
                    "button",
                    {
                        onClick: () => {
                            this.noticeDetail(data)
                        },
                        class: "el-button el-button--default el-button--small el-button--primary",
                        id: data.id,
                        url: data.msgUrl,
                        typeName: data.typeName,
                        billId: data.billId,
                      },
                    "详情"
                    ),
                ]),
                ]),
            });
            },
            // 关闭消息框
            closeNotice(id) {
            if (id && !isNaN(id)) {
                if (this.noticeList[id]) this.noticeList[id].close();
            } else {
                for (let i in this.noticeList) {
                this.noticeList[i].close();
                }
            }
            },
        // 忽略
        noticeReaded(event) {
            console.log(event)
          const id = event.target.getAttribute("id");
          this.markReaded(id);
        },
        // 单个点击
        msgItemClick(id) {
          this.$router.push({ path: "/message-center-unread" });
        },
        // 标记已读
        markReaded(id) {
          let ids =
            id && !isNaN(id)
              ? [id]
              : this.messageList.map((e) => {
                  return e.id;
                });
          if (ids.length) {
            this.$post('/p/msgInmail/consumeMsg', ids).then((res) => {
              if (res.data && res.data.code === "C0000") {
                this.getMessageList();
              }
            });
            // 关闭消息框
            ids.forEach((e) => {
              this.closeNotice(e);
            });
          }
        },
        // 详情
        noticeDetail(event) {
            
          const id = event.id;
          const url = event.msgUrl;
          const typeName = event.typeName;
          const billId = event.billId;
          this.markReaded(id);
          if (typeName === "FILE") {
            this.$utils.listDownLoad({ id: billId });
          } else if (url) {
            let route = this.$utils.getTabDataByUrl(url, true);
            if (route.type === "router") {
              if (route.path.indexOf('payment-application-form-detail') != -1) {
                    if(route.query.bizType == '03' || route.query.bizType == '04' || route.query.bizType == '06'){
                        route.path = 'exchange-settlement-detail'
                        route.query.action = 'view'
                    }else{
                        route.path = 'pledging-payment-detail'
                        route.query.action = 'view'
                    }
              }
              if(route.path.indexOf('/my-logistics/delivery-notice-detail') != -1) {
                route.path = 'logistics-detail'
                route.query.action = 'detail'
              }
              this.$router.push({
                path: route.path,
                query: route.query,
              });
            } else {
              window.open(route.path);
            }
          } else {
            this.msgDrawer.show = true
            // this.$router.push({ name: "message-center-all" });
          }
        },
            getMessageList() {
            this.$post('/p/msgInmail/getCurrentMsg').then((res) => {
                if (res.data && res.data.code === "C0000") {
                this.$store.commit("SET_MESSAGE_LIST", res.data.result);
                }
            });
            },
            reload () {
                this.isReload = false
                this.$nextTick(() => {
                    this.isReload = true
                })
            },
            handleUserCommand (val) {
                if (val == 1) {
                    this.$router.push('/my-center')
                } else if (val == 2) {
                    this.$confirm(`确定进行[退出]操作?`, "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning",
                    }).then(() => {
                        this.$post("/p/user/logout").then(({ data }) => {
                            if (data && data.code === "C0000") {
                                this.$utils.clearLoginInfo()
                                this.$utils.clearAllSessionStorage();
                                window.location.href = window.location.protocol + '//' + window.location.hostname + ':' + window.location.port + '/#/login?v=' + new Date().getTime()
                                window.location.reload(true)
                            }
                        })
                    })
                }
                        
            },
            handlerFold () {
                this.sidebarFold = !this.sidebarFold
            },
            handleClick () {
                setTimeout(() => {
                    this.$router.push({path: this.mainTabsActiveName})
                    this.activeMenu = this.mainTabsActiveName
                }, 50)
            },
            handlerRemove (val) {
                setTimeout(() => {
                    if (val != '/') {
                        console.log(this.$refs.keepView)
                        let tab =  this.mainTabs.filter(item => item.index !== this.mainTabsActiveName)
                        this.mainTabs = tab
                        this.mainTabsActiveName = tab[tab.length -1].index
                        this.activeMenu = this.mainTabsActiveName
                        this.$router.push({path: this.activeMenu})
                    }
                }, 50)
            },
            selectMenu (index) {
                this.bizType.activeIndex = index
                this.activeIndexMenu = index
                if (index == '00') {
                    this.sidebarFold = true
                    this.mainTabsActiveName = '/'
                    this.$router.push({path: '/'})
                } else if (index == '01') {
                    this.mainTabs = [{index: '/', name: '首页'}]
                    this.$router.push({path: 'import-orders-list'})
                    this.mainTabsActiveName = 'import-orders-list'
                    this.sidebarFold = false
                    this.bizTypeNow = '01'
                } else if (index == '06') {
                    this.mainTabs = [{index: '/', name: '首页'}]
                    this.$router.push({path: 'my-list'})
                    this.mainTabsActiveName = 'my-list'
                    this.sidebarFold = true
                } else if (index == '02') {
                    this.mainTabs = [{index: '/', name: '首页'}]
                    this.$router.push({path: 'export-orders-list'})
                    this.mainTabsActiveName = 'export-orders-list'
                    this.sidebarFold = false
                    this.bizTypeNow = '02'
                } else if(index == '07') {
                    this.mainTabs = [{index: '/', name: '首页'}]
                    this.$router.push({path: 'ic-issue'})
                    this.mainTabsActiveName = 'ic-issue'
                    this.sidebarFold = false
                }else{
                    this.sidebarFold = false
                }
                this.$utils.setSessionStorage('bizType', this.bizType)
                if (index == '07' || index == '01' || index == '02') {
                    this.$refs.menu.getMenus()
                }
            },
            getUserInfo() {
                this.$get("/oms/businessWorkbench/getUserInfo").then(({data}) => {
                    if(data && data.code === 'C0000') {
                        this.userInfo = data.result
                        this.bizType = this.$utils.getSessionStorage('bizType') || {}
                        this.bizType.clientImportRole = this.userInfo.clientImportRole
                        this.bizType.clientExportRole = this.userInfo.clientExportRole
                        this.bizType.clientSalesRole = this.userInfo.clientSalesRole
                        this.bizType.clientWmsRole = this.userInfo.clientWmsRole
                        this.userInfo.midName = this.userInfo.realName ? this.userInfo.realName.substring(this.userInfo.realName.length - 2) : ''
                        if (this.userInfo.ownOrgIdsDesc) {
                            this.ownOrgArry = this.userInfo.ownOrgIdsDesc.split(',')
                            this.ownOrgIds = this.userInfo.ownOrgIds.split(',')
                            this.mainOrgId = this.userInfo.mainOrgId
                        }
                        if (!this.bizType.activeIndex) {
                            if (this.bizType.clientImportRole) {
                                this.bizType.activeIndex = '01'
                            } else if (this.bizType.clientExportRole) {
                                this.bizType.activeIndex = '02'
                            }
                            setTimeout(() => {
                                window.location.reload(true)
                            }, 50)
                        }
                        this.$utils.setSessionStorage('bizType', this.bizType)
                        this.$utils.setSessionStorage('userInfo', data.result)
                    }
                })
            },
            checkedOrganizer (idx) {
                this.organizerDialog.idx = this.ownOrgIds[idx]
            },
            checkedOwrg () {
                if (!this.organizerDialog.idx) {
                    return false
                }
                
                this.$post('/p/user/modMainOrgId', {id: this.organizerDialog.idx}).then(({data}) => {
                    if (data && data.code == 'C0000') {
                        this.$message({
                            type: 'success',
                            message: '操作成功！',
                            offset: 380,
                            grouping: true,
                        })
                        this.organizerDialog.show = false
                        this.mainTabs = []
                        this.mainTabsActiveName = '/'
                        this.getUserInfo()
                        this.$router.push({ path: '/' })
                        setTimeout(() => {
                            window.location.reload(true)
                        }, 50)
                       
                    }
                })
                
            },
            getSign () {
                this.$get('/oms/principalIntegral/sign').then(({data}) => {
                    if(data.code === 'C0000') {
                        if(data.message == '签到成功') {
                            this.$message({
                                type: 'success',
                                message: '签到成功!',
                                offset: 380,
                                grouping: true,
                            })
                        }
                    }
                })
            },
            routeHandle (route) {
                if (route.meta && route.meta.keepAlive) {
                    this.isHelp = false
                } else {
                    this.isHelp = true
                }
                if (route.path == '/') {
                    this.activeIndexMenu = '00'
                } else if (route.path == '/my-list') {
                    this.activeIndexMenu = '06'
                } else {
                    if (route.meta.type) {
                        this.activeIndexMenu = route.meta.type
                    }
                }
                let tab = this.mainTabs.filter(item => item.name === route.name)[0]
                if (!tab) {
                    tab = {
                        menuId: route.meta.menuId || route.name,
                        name: route.name,
                        title: route.meta.title,
                        index: route.path,
                        keepAlive: route.meta.keepAlive
                    }
                    this.mainTabs = this.mainTabs.concat(tab)
                }
                this.mainTabsActiveName = tab.index
                if (['首页', '我的'].includes(route.name) || route.meta.keepAlive || route.meta.sidebarFold) {
                    this.sidebarFold = true
                } else {
                    this.sidebarFold = false
                }
                let viewTemp = []
                this.mainTabs.map(e => {
                    let view = e.index.replace('/', '')
                    if (view) {
                        viewTemp.push(view)
                    }
                })
                this.keepAliveView = viewTemp
        },
        goOldSystem () {
            if (process.env.VUE_APP_ENV == 'prod') {
                window.location.href = `${process.env.VUE_APP_SYSTEM}/#/sso?token=` + vueCookie.get('token')
            } else {
                window.location.href = `${process.env.VUE_APP_SYSTEM}/#/sso?token=` + vueCookie.get('token')
            }
        },
            //公告详情
            open(){
                this.drawer2=false
            },
            close(){
                this.drawer2=true
            },
            organizerClose () {
                this.organizerDialog.show = false
                this.organizerDialog.idx = ''
            },
            getOrginzer () {
                this.organizerDialog.idx = this.mainOrgId
                this.organizerDialog.show = true
            },
            getService () {
                this.service.show = true
            },
            getAttachUrl() {
                this.$post('/p/user/getAttachUrlById').then(({ data }) => {
                    if(data.code === 'C0000') {
                    this.attachUrl = data.message
                    }
                })
            },
            //未读消息数量
            getDataList () {
                this.$post('/p/msgInmail/list', {pageNum: 1, pageSize: 10, status: 0}).then(({data}) => {
                    if (data && data.code == 'C0000') {
                        this.messageTotal = data.result.total
                    }
                })
            },
            mesList(){
                this.getDataList()
            },
            sysChange () {
                this.$confirm('您确定要切换到旧系统吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    if (process.env.VUE_APP_ENV == 'prod') {
                        window.location.href = `${process.env.VUE_APP_SYSTEM}/#/sso?token=` + vueCookie.get('token')
                    } else {
                        window.location.href = `${process.env.VUE_APP_SYSTEM}/#/sso?token=` + vueCookie.get('token')
                    }
                })
            },
            helpMesg () {
                this.$refs.issue.btn3()
            },
            getCustomerFeedbackList () {
                this.$post('/crm/client/customerFeedback/list').then(({data}) => {
                    if (data && data.code == 'C0000') {
                        this.unReadCount = data.extra.unReadCount || 0
                    }
                })
            },
        },
        watch: {
            $route: 'routeHandle'
        }
    }
    </script>
    
    <style lang="scss">
    .content-layout {
        background-image: url(@/assets/img/bg1.jpg);
        width: 100%;
        height:100%;
        // background-repeat: no-repeat,no-repeat;
        background-position: top,bottom;
        .customer{
            .el-drawer{
                padding: 0 20px
            }
            //客服
            .customerService{
                width: 420px;
                padding-top: 40px;
                text-align: center;
                .img{
                    width: 120px;
                    height: 120px;
                    margin: 0 auto;
                    border-radius: 50%;
                    img{
                        width: 100%;
                    }
                }
                .info{
                    display: flex;
                    justify-content: space-between;
                    font-size: 16px;
                    color: #000000;
                    .phone{
                        display: flex;
                        align-items: center;
                        svg{
                            width: 12px;
                            margin-right: 10px;
                        }
                    }
                    .email{
                        display: flex;
                        align-items: center;
                        svg{
                            width: 15px;
                            margin-right: 10px;
                            color: #A1A4A7;
                        }
                    }
                }
                .name{
                    background-color: #F0F2F5;
                    color: #F87243 ;
                    display: inline-block;
                    border-radius: 4px;
                    padding: 4px 16px;
                    font-size: 16px;
                    font-weight: bold;
                    margin: 15px 0 20px;
                }
                .address{
                    display: flex;
                    margin-top: 15px;
                    font-size: 16px;
                    text-align: left;
                    svg{
                        width: 15px;
                        height: 24px;
                        margin-right: 10px;
                    }
                }
            }
        }
        .main-left{
            width: 194px;
        }
        .isHidden{
            width: 0;
            height: 0;
        }
        .main-heard {
            position: relative;
            .nav-conter {
                display: flex;
                align-items: center;
                justify-content: center;
                height: 60px;
                img {
                    width: 146px;
                    height: 31px;
                }
                .ab-select {
                    height: 28px;
                    margin-left: 15px;
                    line-height: 28px;
                    border: none;
                    background-color: #E7F0FD;
                    border-radius: 8px;
                    padding: 0 10px;
                    font-size: 16px;
                    cursor: pointer;
                    option {
                        cursor: pointer;
                    }
                    .icon-svg {
                        margin-left: 5px;
                        vertical-align: middle;
                    }
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }
            }
            .el-menu {
                border-right: none;
                background:none;
                border-bottom:none;
            }
            .el-menu-item {
                font-size: 16px;
                margin-right: 20px;
            }
            .icon-svg {
                height: 16px;
                width: 16px;
                margin-right: 5px;
            }
            .el-menu--horizontal .el-menu-item:not(.is-disabled):focus, .el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
                background-color: transparent;
            }
            .el-menu--horizontal > .el-menu-item.is-active {
                background-image: url(@/assets/img/nav-active.png);
                background-repeat: no-repeat;
                background-position:bottom;
                font-weight: bold;
                // border-bottom:none;
            }
            .nav-right {
                text-align: right;
                position: relative;
                ul {
                    display: flex;
                    flex-wrap: nowrap;
                    justify-content:right;
                    margin-top: 19px;
                    margin-right: -5px;
                    li {
                        width: 47px;
                        margin-left: 40px;
                        font-size: 14px;
                        font-family: PingFangSC-Regular, 'Noto Sans SC', Microsoft YaHei;
                        font-weight: 400;
                        color: #000000;
                        cursor: pointer;
                        .icon-svg {
                            width:14px;
                            height: 14px;
                            vertical-align: middle;
                        }
                    }
                }
                .user-info {
                    cursor: pointer;
                    position: absolute;
                    right: 0;
                    top: 10px;
                    padding-right: 10px;
                    z-index: 1;
                    .user-name {
                        // background-color: #1F77F4;
                        color: #ffffff;
                        width: 32px;
                        height: 32px;
                        border-radius: 50%;
                        overflow: hidden;
                        // padding-top: 10px;
                        text-align: center;
                        img {
                            width: 100%;
                        }
                    }
                    
                }
                .system-change {
                    width: 80px;
                    height: 60px;
                    position: absolute;
                    cursor: pointer;
                    right: 430px;
                    .icon-svg {
                        width: 100%;
                        height: 100%;
                    }
                    img {
                        width: 44px;
                        height: 44px;
                    }
                }
            }
            .yixiu-logo {
                position: absolute;
                cursor: pointer;
                top: 80px;
                right: 100px;
                .logo-1 {
                    width: 18px;
                    margin-right: 5px;
                }
                .tex {
                    font-size: 16px;
                    font-weight: 600;
                }
                .logo-2 {
                    position: absolute;
                    top: -20px;
                    right: -78px;
                }
            }
        }
        .tankage {
            padding: 20px;
            background-color: #F4F4F6;
            overflow-y: auto;
            border-bottom-left-radius: 8px;
            border-bottom-right-radius: 8px;
            &::-webkit-scrollbar {
                width: 8px;
                height: 8px;
            }
            &::-webkit-scrollbar-thumb {
                border-radius: 3px;
                background: #aaa;
                &:hover {
                    background: #999;
                }
            }
            &::-webkit-scrollbar-track {
                background: transparent;
            }
            .tankage-main {
                min-height: 100%;
                background-color: #ffffff;
                box-shadow: 0px 3px 79px 0px rgba(0,0,0,0.05);
                border-radius: 8px;
            }
        }
        .footer {
            line-height: 40px;
            text-align: center;
            border-top: 1px solid #F0F2F5;
            position: relative;
            padding-left: 95px;
            img {
                position: absolute;
                height: 40px;
                width: 40px;
                // top: -20px;
                left: calc(50% - 260.93px);
            }
            .file {
                letter-spacing:16px;
                font-size: 16px;
                font-weight: 600;
            }
        }
        .sidebarfold {
            position: absolute;
            top: 200px;
            background-color: #ffffff;
            height: 64px;
            width: 49px;
            border: 1px solid #f3f3f5;
            border-top-right-radius: 30px;
            border-bottom-right-radius: 30px;
            cursor: pointer;
            .icon-svg {
                width: 16px;
                height: 16px;
                margin-top: 22px;
                margin-left:13px;
            }
        }
        //消息
       .message {
           text-align: left;
           /*去掉切换时el-tab-pane底部的蓝色下划线*/
           .el-tabs__active-bar {
            background-color: transparent !important;
           }
            /*去掉tabs底部的下划线*/
            .el-tabs__nav-wrap::after {
            position: static !important;
           }
         
            .el-badge__content.is-fixed {
                top: 6px;
            }
            .el-drawer.rtl.open {
                border-radius: 16px;
            }
         
           .el-tabs__item.is-top {
                padding: 0;
                margin-right: 40px;
                font-size: 16px;
                    &.is-active {
                    background-image: url(@/assets/img/nav-active.png);
                    background-repeat: no-repeat;
                    background-position: bottom;
                    border-bottom: none;
                    font-size: 18px;
                }
            }
            .el-drawer__body {
                padding: 20px 0;
                .el-tabs__header {
                    padding: 0 40px;
                }
            }
         
           .off {
                position: absolute;
                top: 28px;
                right: 40px;
            cursor: pointer;
            .icon-svg {
                width: 19px;
                height: 19px;
                vertical-align: middle;
            }
           }
        }
        .ab-content-details {
            width: 1360px;
            margin: 0 auto;
        }
        .main-content {
            .nav-tab {
                .icon-svg {
                    width: 6.3px;
                    height: 6.3px;
                    margin-bottom: 1px;
                    margin-left: 8px;
                }
            }
            .el-tabs.actived-manue {
                width: calc(100% - 360px);
            }
        }
    }
    .organizer-dialog {
        .el-dialog__footer {
            text-align: center;
            padding-top: 0;
        }
        .el-dialog__body {
            padding: 40px;
        }
        .org-item {
            width: 100%;
            height: 60px;
            border-radius: 15px;
            position: relative;
            border: 2px solid #EEEEEE;
            margin-bottom: 20px;
            cursor: pointer;
            &.isActived {
                border: 2px solid #0a7cff;
                .org-tel {
                    background-color: #0a7cff;
                }
            }
            .org-tel {
                width: 37px;
                height: 36px;
                background-color: #EEEEEE;
                color: #ffffff;
                border-radius: 15px 0 15px 0;
                position: absolute;
                cursor: pointer;
                top: -2px;
                left: -2px;
                .el-icon {
                    margin: 12px;
                    width: 12px;
                    height: 8px;
                    font-weight: bold;
                }
            }
            .org-name {
                font-size: 16px;
            }
            div:last-child {
                text-align: center;
                line-height: 60px;
            }
    
        }
       
    
    }
    .service-dialog {
        .el-drawer__body {
            margin: auto;
        }
        
    }
    .notify-button {
        button:first-child {
            border-color: #F0F2F5;
            background-color: #ffffff;
            border-radius:8px
        }
        button:last-child {
            margin-left: 5px;
            background-color: #0A7CFF;
            color:#ffffff;
            border-color:#0A7CFF;
            border-radius:8px
        }
    }
    </style>